module.exports = __webpack_public_path__ + "assets/img/main-logo-zhangjiakou.789e38d9.png";